import { BracketSeries } from "@portal-frontend-ssr/blast-api";

// Pulled in from https://github.com/blastorg/tournaments-api/blob/main/src/services/mapMatchesIntoBracketsV2/helpers.ts#L6
export function isMatchCompleted(match: BracketSeries) {
  if (match.maps?.length === 0) return false;

  const matchScores = [match.teamAScore, match.teamBScore];
  switch (match.type) {
    case "BO1":
      return matchScores.some((score) => score === 1);
    case "BO2":
      return false;
    case "BO3":
      return matchScores.some((score) => score === 2);
    case "BO5":
      return matchScores.some((score) => score === 3);
    case "BO7":
      return matchScores.some((score) => score === 4);
    default:
      throw new Error(`Unknown match type ${match.type as string}`);
  }
}
